/* earbit use-cases rail: prev/next buttons page the native scroller by one
   card and disable themselves at either end. */

if (!customElements.get('use-cases-rail')) {
  customElements.define(
    'use-cases-rail',
    class UseCasesRail extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-rail]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.rail || !this.prev || !this.next) return;

        this.onPrev = () => this.page(-1);
        this.onNext = () => this.page(1);
        this.onScroll = () => this.update();
        this.prev.addEventListener('click', this.onPrev);
        this.next.addEventListener('click', this.onNext);
        this.rail.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.update();
      }

      disconnectedCallback() {
        this.prev?.removeEventListener('click', this.onPrev);
        this.next?.removeEventListener('click', this.onNext);
        this.rail?.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      page(direction) {
        const card = this.rail.firstElementChild;
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
        this.rail.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap) });
      }

      update() {
        const max = this.rail.scrollWidth - this.rail.clientWidth - 1;
        this.prev.disabled = this.rail.scrollLeft <= 0;
        this.next.disabled = this.rail.scrollLeft >= max;
      }
    },
  );
}
